import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
import get from 'lodash/get';
import moment from 'moment';
import {document} from 'ssr-window';
import StorageUtils from '@spothero/utils/storage';
import SearchUtils from 'search/search-utils';
import SegmentUtils from 'utils/segment';
import UserUtils from 'user/user-utils';
import getParkingType from '../utils/parking-type';

/* eslint-disable camelcase, no-undefined */
export default function({
    userId = null,
    city,
    destination = null,
    event = null,
    isMonthly,
    starts,
    ends,
    spot,
    referrer,
    referrerAffiliate,
}) {
    const {
        parking_spot_id: spotId,
        facility: {
            title,
            airport,
            amenities_full: facilityAmenities,
            operator_id: operatorId,
            cancellation_allowed: cancellationAllowed,
            tag,
        },
        selectedRate,
        distanceInMiles,
        drivingDuration,
        rating_info: ratingInfo,
    } = spot;
    const isAirport = !isNil(airport);
    const isEvent = !isEmpty(event);
    const parkingType = getParkingType({
        isMonthly,
        isAirport,
        isEvent,
    });
    const price = selectedRate
        ? (selectedRate.price / 100).toString()
        : undefined;
    const currency = selectedRate
        ? selectedRate.currency_type
        : UserUtils.CURRENCY_TYPES.USD.toLowerCase();
    const startsMoment =
        selectedRate && selectedRate.starts
            ? moment(selectedRate.starts)
            : moment(starts);
    const endsMoment =
        selectedRate && selectedRate.ends
            ? moment(selectedRate.ends)
            : isMonthly
            ? startsMoment.clone().add(1, 'month')
            : moment(ends);
    const amenities = selectedRate ? selectedRate.amenities : facilityAmenities;
    const reservationDuration = parseInt(
        moment.duration(endsMoment.diff(startsMoment)).format('m'),
        10
    );
    const tzDiff =
        moment()
            .tz(city.timezone)
            .utcOffset() - moment().utcOffset();
    const timeUntilReservationStart =
        parseInt(moment.duration(startsMoment.diff(moment())).format('m'), 10) -
        tzDiff;
    const fromScreen = SearchUtils.getReferrerDetails({
        referrer,
    });
    const spotMeta = StorageUtils.get(SearchUtils.SEGMENT_SPOT_META);
    const taxBreakdown = get(selectedRate, 'price_breakdown.items');
    let sortType;
    let spotRank;

    if (spotMeta) {
        const {rank, sortBy: sortByMeta} = spotMeta;

        spotRank = rank;
        sortType = sortByMeta;

        StorageUtils.remove(SearchUtils.SEGMENT_SPOT_META);
    }

    const properties = {
        'parking type': parkingType, // MARKED FOR DEPRECATION: parking_type will be used moving forward
        'spot id': spotId, // MARKED FOR DEPRECATION: parking_spot_id will be used moving forward
        'reservation duration': reservationDuration, // MARKED FOR DEPRECATION: reservation_duration will be used moving forward
        'time until reservation start': timeUntilReservationStart, // MARKED FOR DEPRECATION: time_until_reservation_start will be used moving forward
        'from screen': fromScreen, // MARKED FOR DEPRECATION
        'referrer affiliate': referrerAffiliate, // MARKED FOR DEPRECATION: referrer_affiliate will be used moving forward
        referrer: referrer || document.referrer,
        reservation_duration: reservationDuration,
        time_until_reservation_start: timeUntilReservationStart,
        referrer_affiliate: referrerAffiliate,
        currency,
        price,
        parking_type: parkingType,
        city: city.slug,
        state: city.state,
        google_places_name: get(
            destination,
            'google_places.0.google_places_name'
        ),
        google_places_place_id: get(
            destination,
            'google_places.0.google_places_place_id'
        ),
        operator_id: operatorId,
        parking_spot_id: spotId,
        parking_spot_name: title,
        spot_rank: spotRank,
        travel_distance: isNumber(distanceInMiles)
            ? distanceInMiles * 1609
            : undefined,
        travel_distance_type: isNil(drivingDuration) ? 'walking' : 'driving',
        star_rating: get(ratingInfo, 'star_rating'),
        amenities: amenities.map(({name}) => name),
        free_cancellation: cancellationAllowed !== 'no',
        taxes_fees: taxBreakdown
            ? taxBreakdown.map(({type, price: itemPrice}) => ({
                  type,
                  price: itemPrice,
              }))
            : undefined,
        sort_type: sortType,
        ...(destination &&
            !isEmpty(destination) && {
                destination_id: destination.id,
                destination_name: destination.title,
            }),
        ...(isEvent && {
            event_id: event.id,
            event_name: event.title,
        }),
        ...(isAirport && {
            airport_code: airport.details.code,
            banner_details: !isNil(tag) ? tag : undefined,
            shuttle_available: Boolean(get(airport, 'shuttle.duration')),
            shuttle_min_frequency: get(airport, 'shuttle.slow_frequency'),
            shuttle_max_frequency: get(airport, 'shuttle.fast_frequency'),
            shuttle_duration: get(airport, 'shuttle.duration'),
            shuttle_24_7: Boolean(airport.shuttle.hours.text.length),
            shuttle_hours: airport.shuttle.hours.periods,
        }),
    };

    SegmentUtils.page({
        name: 'Spot Details',
        properties,
    });
}
